import { name } from "../utils/dom";
import Head from "./head";
import { useEffect } from "react";
import VerifyBadge from "./verify-badge";
import Tooltip from "./tooltip";
import shared from "../data/js/shared";
const { verifiedTooltip, verifiedTooltip2 } = shared.product;

const SellerProfile = (props) => {
  useEffect(() => {
  }, []);

  const { user } = props;
  const title = `Browse ${user?.firstName || "Seller"}'s Listings at Sellwild`;
  const lastDigit = user?.id ? user.id % 10 : undefined;
  const photo = user?.photos?.url;
  if (!user) return <div className="seller-profile">
  <Head>
    <title>Loading...</title>
  </Head>
  </div>;
  const locationText = user?.locationText || "";

  return (
    <div className="seller-profile">
      <Head>
        <title>{title}</title>
      </Head>
      <div className="seller-profile-header">
        <div className="profile-card" >
          <div className="inner">
          {user?.trustLevel >= 2 ? (
              <Tooltip
                position="below"
                triggerElement="#seller-profile-photo"
                theme="dark"
                triggerEvent="hover"
              >
                {verifiedTooltip}
                <br />
                {verifiedTooltip2}
              </Tooltip>
            ) : (
              ""
            )}

            <div className="seller-profile-photo" id="seller-profile-photo">
              <div className="seller-profile-photo-circle">
                <img
                  src={
                    photo && !photo.match(/default/)
                      ? photo
                      : `/images/svg/profile-placeholder-${lastDigit}.svg`
                  }
                  alt="Seller profile"
                />
              </div>
              <VerifyBadge user={user} />
            </div>
            <div className="seller-profile-text">
              <div className="seller-profile-name">{name(user)}</div>
              <div className="seller-profile-location">{locationText}</div>
            </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default SellerProfile;
